module.exports = __webpack_public_path__ + "static/media/logo-header-old2.85245203.svg";